export default __webpack_public_path__ + "images/0xc36cae799b758d04dac9b3a1fd59755c4a8ae721.png";